import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";
import Adherent from "./Adherent";
import Children from "./Children";
import Payer from "./Payer";
import Spouse from "./Spouse";

const generateProofForm = ({ hasOtherPayer, hasChildren, hasSpouse }) => ({
  [SUBSCRIPTION_FORM_KEYS.PROOF.ADHERENT]: Adherent,
  [SUBSCRIPTION_FORM_KEYS.PROOF.PAYER]: hasOtherPayer ? Payer : null,
  [SUBSCRIPTION_FORM_KEYS.PROOF.SPOUSE]: hasSpouse ? Spouse : null,
  [SUBSCRIPTION_FORM_KEYS.PROOF.CHILDREN]: hasChildren ? Children : null,
});

export default generateProofForm;
